export enum GlobalPermissionModules {
  EmployeeGroups = 'employeeGroups',
  Benefits = 'benefits',
  FlexBenefit = 'flexBenefit',
  BenefitAlternatives = 'benefitAlternatives',
  Administrators = 'administrators',
  OrganisationStructure = 'organisationStructure',
}

export enum LocalPermissionModules {
  Employees = 'employeeModule',
  News = 'newsModule',
  History = 'historyModule',
}

export enum PermissionOptions {
  None = 'none',
  View = 'view',
  Edit = 'edit',
}

export enum PermissionLevels {
  Global = 'global',
  Local = 'local',
  AllLocal = 'localAll',
}
